import { eventsRequest } from '../../utils/eventsRequest';
import { AxiosError } from 'axios';
import { ErrorResponse } from '../../types';

const savePaymentMethod = async (paymentMethodDetails: {
    payerId: number;
    token: string;
    firstName: string;
    lastName: string;
    phone: string;
    address: string;
    country: string;
    province: string;
    city: string;
    zip: string;
}) => {
    let arrayResponse = {
        success: false,
        message: 'Failed to save payment method.',
    };

    try {
        const response = await eventsRequest('/payment/method', 'post', paymentMethodDetails);

        if (response.status === 200 || response.status === 201) {
            arrayResponse.success = true;
            arrayResponse.message = 'Payment method saved successfully.';
        }
        return arrayResponse;
    } catch (error) {
        const axiosError = error as AxiosError<ErrorResponse>;
        if (axiosError.response) {
            arrayResponse.message = axiosError.response.data.message || 'An error occurred while saving payment method.';
        }
        return arrayResponse;
    }
};

export default savePaymentMethod;
